// Module
var code = `<template>
  <require from="./portfolio-value-widget.scss"></require>

  <div class="portfolio-value-widget">
    <mdc-circular-progress if.bind="loading"></mdc-circular-progress>
    <!-- chart slightly sticks out from its boundaries, 96% makes sure there's no scroll -->
    <div show.bind="!loading && !error" class="portfolio-value-widget__chart" style="height: 96%" element.ref="chart">
    </div>
    <mdc-segmented-button if.bind="showMode" single change.trigger="modeChanged() & stopPropagation">
      <button mdc-segmented-button-segment checked.bind="showPL">P&L</button>
      <button mdc-segmented-button-segment checked.bind="showValue">Value</button>
    </mdc-segmented-button>
    <message if.bind="error" icon="error" colour="mdc-theme--error" class="portfolio-value-widget__error">
      \${error.message}</message>
    <div if.bind="noGL" class="portfolio-value-widget__no-gl-warning warning">
      Warning: No GL data available for this period
    </div>
  </div>
</template>
`;
// Exports
export default code;